export default [
  {
    path: "/bus-management",
    name: "BusManagement",
    meta: { title: "Bus Management"},
    children: [
      {
        path: "bus",
        name: "Bus",
        meta: { title: "Buses"},
        component: () =>import("@/modules/bus-management/bus/views/BusList.vue"),
      },
      {
        path: "report",
        name: "Report",
        meta: {title: "Reports"},
        component: () => import("@/modules/bus-management/report/views/ReportList.vue"),
      },
      {
        path: "city",
        name: "CityList",
        component: () =>import("@/modules/bus-management/city/views/CityList.vue"),
      },
    ],
  },
];
